// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"e1f57566","815":"3804287a"}[chunkId] + ".chunk.js";
};